import { fetchAPI } from '../helpers';
import AppContext from '../AppContext';

class ContentService {
    static getContent = (contentId, groupId) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.ContentService}${platformId}/${contentId !== undefined ? contentId : ''}`,
            method: 'POST',
            aux: contentId,
            body: {
                groupId,
            },
        });
    };

    static getShareURL = () => {
        let appContext = new AppContext();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return `${config.ContentService}${platformId}/share`;
    };

    static shareContent = (shareURL, contentIds, expireDate) => {
        let appContext = new AppContext();
        let token = appContext.getToken();

        return fetchAPI({
            token,
            url: shareURL,
            method: 'POST',
            body: {
                contentIds, // Màxim 10 items actualment
                expireDate, //: '2017-12-01' // O format ISO amb hora, es transforma, si no te TZ es passa a UTC
            },
        });
    };

    static setContentPreviewImage = (contentId, previewImage) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token,
            url: `${config.ContentService}${platformId}/${contentId}/image`,
            method: 'PUT',
            body: {
                previewImage,
            },
        });
    };

    static removeContentPreviewImage = (contentId) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token,
            url: `${config.ContentService}${platformId}/${contentId}/image`,
            method: 'DELETE',
            body: {},
        });
    };

    static setContentSections = (contentId, currentLanguage, groupId, sections, version) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.ContentService}${platformId}/${contentId}/${currentLanguage}/sections`,
            method: 'PUT',
            body: {
                groupId,
                sections,
                version,
            },
        });
    };

    static createContentLocalization = (contentId, currLang, name, groupId) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token,
            url: `${config.ContentService}${platformId}/${contentId}/${currLang}`,
            method: 'PUT',
            body: {
                groupId,
                name,
            },
        });
    };

    static removeContentLocalization = (contentId, currLang, groupId) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token,
            url: `${config.ContentService}${platformId}/${contentId}/${currLang}`,
            method: 'DELETE',
            body: {
                groupId,
            },
        });
    };

    static deleteContent = (contentId, groupId) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token,
            url: `${config.ContentService}${platformId}/${contentId}`,
            method: 'DELETE',
            body: {
                groupId,
            },
        });
    };

    static setContentDefinition = (contentId, contentDefinition) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token,
            url: `${config.ContentService}${platformId}/${contentId}`,
            method: 'PUT',
            body: {
                ...contentDefinition,
            },
        });
    };

    static setContentName = (contentId, langCode, name, groupId) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.ContentService}${platformId}/${contentId}/${langCode}/name`,
            method: 'PUT',
            body: {
                name,
                groupId,
            },
        });
    };

    static setContentGroup = (contentId, newGroupId) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token,
            url: `${config.ContentService}${platformId}/${contentId}/group`,
            method: 'PUT',
            body: {
                newGroupId,
            },
        });
    };

    static removeContentGroup = (contentId) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token,
            url: `${config.ContentService}${platformId}/${contentId}/group`,
            method: 'DELETE',
            body: {},
        });
    };

    static contentVersionById = (contentId, groupId) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token,
            url: `${config.ContentService}${platformId}/${contentId}/version`,
            method: 'POST',
            body: {
                groupId,
            },
        });
    };

    static getContentDefinitions = () => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token,
            url: `${config.ContentService}${platformId}`,
            method: 'GET',
        });
    };

    //Publish
    static getPendingPublishResources = () => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.ContentService}${platformId}/pending-publish`,
            method: 'GET',
        });
    };

    static publishResource = (currentId, groupId) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.ContentService}${platformId}/${currentId}/publish`,
            method: 'POST',
            body: {
                groupId,
            },
        });
    };

    // Favs
    static getFavorites = () => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.ContentService}${platformId}/fav/`,
            method: 'GET',
        });
    };

    static addFavorite = (contentId) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.ContentService}${platformId}/fav/${contentId}`,
            method: 'PUT',
        });
    };

    static removeFavorite = (contentId) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.ContentService}${platformId}/fav/${contentId}`,
            method: 'DELETE',
        });
    };

    // Content creation
    static createContent = (name, language, date, objectType, groupId) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token,
            url: `${config.ContentService}${platformId}/${objectType}/`,
            method: 'PUT',
            body: {
                name,
                language,
                date,
                groupId,
            },
        });
    };

    static createMeeting = (name, language, date) => {
        return ContentService.createContent(name, language, date, 'meeting');
    };

    static createCollection = (name, language) => {
        return ContentService.createContent(name, language, undefined, 'collection');
    };

    static createCategory = (name, language, groupId) => {
        return ContentService.createContent(name, language, undefined, 'category', groupId);
    };

    static createMetadocument = (name, language, groupId) => {
        return ContentService.createContent(name, language, undefined, 'metadocument', groupId);
    };

    static createExternalLink = (name, language, groupId) => {
        return ContentService.createContent(name, language, undefined, 'external-link', groupId);
    };

    // CATEGORY Endpoints
    static copyContentToCategory = (originContentId, destContentId) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token,
            url: `${config.ContentService}${platformId}/${originContentId}/copy`,
            method: 'POST',
            body: {
                categoryId: destContentId,
                //groupId
            },
        });
    };

    // Mtg notes & attachments
    static setMtgNotes = (contentId, notes, version) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token,
            url: `${config.ContentService}${platformId}/meeting/${contentId}/notes`,
            method: 'PUT',
            body: {
                notes,
                version,
            },
        });
    };

    static uploadAttachment = (contentId, filename, contentType) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token,
            url: `${config.ContentService}${platformId}/meeting/${contentId}/file`,
            method: 'PUT',
            body: {
                filename,
                contentType,
            },
        });
    };

    static deleteAttachment = (contentId, fileId) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token,
            url: `${config.ContentService}${platformId}/meeting/${contentId}/file`,
            method: 'DELETE',
            body: {
                fileId,
            },
        });
    };

    static getPlatformDefinition = () => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.ContentService}${platformId}`,
            method: 'GET',
        });
    };
}

export default ContentService;
